import {theme} from "Theme";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const TotalField = ({label, total, bold = false}) => {
    return (
        <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={2}
            my={2}
        >
            <Typography
                variant="subtitle1"
                textTransform="uppercase"
                color="primary.dark"
                fontSize={theme.typography.fontSize}
                fontWeight={bold ? 500 : "inherit"}
            >
                {label}:
            </Typography>
            <Typography variant="subtitle2" color="text.primary">
                {total || 0}
            </Typography>
        </Stack>
    );
};

export default TotalField;
